module.exports = __webpack_public_path__ + "media/images/logo/ekuitas-invest-67b281c0fee609d6df65827d2d102edd.svg";